import { Modal } from "antd";
import { IconDisconected } from "../../../Icons/IconDisconected";
import { Botao } from "../../Botao";

interface ModalCheckOfflineProps {
  isModalOpen: boolean;
  closeModal?: () => void;
}

export function ModalCheckOffline({ isModalOpen, closeModal }: ModalCheckOfflineProps) {
  return (
    <Modal
      className="h-[80vh] flex justify-center items-center"
      open={isModalOpen}
      onCancel={closeModal}
      title="Erro de conexão"
      footer={
       <div className="flex flex-row items-center justify-center gap-4">
        <Botao
          type="button"
          onClick={closeModal}
          texto="Ok"
          className="bg-primary hover:bg-primary-hover text-white"
        />
      </div>
      }
    >
      <div className="flex flex-col items-center w-[350px] justify-center">
        <IconDisconected />
        <span className="mt-2 text-center">Ocorreu um erro ao tentar cadastrar, verifique a conexão com a internet e tente novamente!</span>
        </div>
    </Modal>
  );
}
